import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import SobreNosotros from '../components/SobreNosotros';
import Tienda from '../components/Tienda';
import Premios from '../components/Premios';
import RecetarioCarousel from '../components/RecetarioCarousel';
import Cart from '../components/Cart';
import Footer from '../components/Footer';

const Home = () => {
  const { hash } = useLocation();

  /* Al entrar a la página principal sin hash, ir al top (p. ej. desde Inicio en Equipo) */
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const el = document.getElementById(id);
    if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
  }, [hash]);

  return (
    <>
      <Hero />
      <SobreNosotros />
      <Tienda />
      <Premios />
      <RecetarioCarousel />
      <Cart />
      <Footer />
    </>
  );
};

export default Home;
